import { createAsyncThunk } from "@reduxjs/toolkit";
import { PropertyFacility } from "../../../client/services";
import { toastHandler } from "../../../utils/toastHandler";
import { FindPropertyFacility, GetPropertyFacility } from "../../propertyFacility/api/interface";

export const findSelectPropertyFacility = createAsyncThunk(
  "selectPropertyFacility/findSelectPropertyFacility",
  async (values: FindPropertyFacility, { rejectWithValue }) => {
    try {
      const response = await PropertyFacility.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const searchSelectPropertyFacility = createAsyncThunk(
  "selectPropertyFacility/searchSelectPropertyFacility",
  async (values: FindPropertyFacility, { rejectWithValue }) => {
    try {
      const response = await PropertyFacility.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);


export const getSelectPropertyFacility = createAsyncThunk(
  'selectPropertyFacility/getSelectPropertyFacility',
  async ({ id }: GetPropertyFacility, { rejectWithValue }) => {
    try {
      const response = await PropertyFacility.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
